import type { Options } from 'integrations/hooks/useFetch';

const urlWithAuthParams = (url: string, options: Options): string =>
  `${url}?tenantId=${options.tenantId}&clientSecret=${options.clientSecret}&clientId=${options.clientId}`;

export default urlWithAuthParams;
